export { default } from './protected-route';
